import { useTheme } from "@mui/material";

export interface ICloseSvgIconProps {
    fill?:string
    width?:number,
    height?:number,
}

export default function CloseSvgIcon({width = 101, height= 101, ...other}: ICloseSvgIconProps) {

    const theme = useTheme();

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 101 101" fill="none" {...other}>
            <path d="M50.4998 0.916016C23.1298 0.916016 0.916504 23.1294 0.916504 50.4994C0.916504 77.8694 23.1298 100.083 50.4998 100.083C77.8698 100.083 100.083 77.8694 100.083 50.4994C100.083 23.1294 77.8698 0.916016 50.4998 0.916016ZM10.8332 50.4994C10.8332 28.5835 28.584 10.8327 50.4998 10.8327C59.6728 10.8327 68.1019 13.9564 74.7957 19.2123L19.2128 74.7952C13.9569 68.1014 10.8332 59.6723 10.8332 50.4994ZM50.4998 90.166C41.3269 90.166 32.8978 87.0423 26.204 81.7864L81.7869 26.2035C87.0428 32.8973 90.1665 41.3264 90.1665 50.4994C90.1665 72.4152 72.4157 90.166 50.4998 90.166Z" fill="#B3261E" />
        </svg>

    );
}
